import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { Button, ButtonGroup, IconButton } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import useTrackingLink from '../../../hooks/orders/useTrackingLink';
import { setSnackBar } from '../../../states/app/staticSlice';

//@ Composant pour se rediriger vers le lien de tracking
//@ shipper = 'DPD' | 'UPS' ...
//@ tracking = tracking number
//@ variant = 'short' | 'medium' | 'long'
//@ size = 'small' | 'medium' | 'large'

export const TrackingNumberButton = ({
  shipper,
  tracking,
  variant = 'short',
  size = 'small',
}) => {
  const { getTrackingLink } = useTrackingLink();
  const dispatch = useDispatch();

  const handleOpenLink = async () => {
    const body = { shipper: shipper, tracking: tracking };
    const url = await getTrackingLink(body);
    if (!url) {
      console.warn(
        'Failed to Generate tracking list for this shipper and tracking number',
        body
      );
      dispatch(
        setSnackBar({
          open: true,
          color: 'warning',
          message:
            'Failed to generate tracking list for this shipper and tracking number',
        })
      );
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  return (
    <ButtonGroup variant="outlined" color="primary">
      {variant === 'short' ? (
        <IconButton
          size={size || 'small'}
          disabled={!tracking || !shipper}
          onClick={async () => await handleOpenLink()}
        >
          <OpenInNewRoundedIcon color="primary" fontSize="inherit" />
        </IconButton>
      ) : (
        <Button
          size={size || 'small'}
          endIcon={<OpenInNewRoundedIcon />}
          disabled={!tracking || !shipper}
          onClick={async () => await handleOpenLink()}
        >
          Suivre le colis
          {variant === 'long' ? ` (${shipper || ''})` : ''}
        </Button>
      )}
    </ButtonGroup>
  );
};
